// @ts-nocheck
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { typographyTitleStyles } from "@store/Themes/common/mixins/typography";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export interface TypographyNoResultsParameters {
    separated?: boolean;
    spaced?: boolean;
}

export const typographyGetNoResultsProps = (
    parameters: TypographyNoResultsParameters = {},
): TypographyPresentationProps => {
    const { separated, spaced } = parameters;

    return {
        forwardAs: "p",
        css: css`
            ${({ theme }) => {
                const output = [];

                if (separated) {
                    output.push(css`
                        border-top: ${pxToRem(1)} solid ${getColor("common.border")};
                    `);
                }

                if (separated || spaced) {
                    output.push(css`
                        ${separated ? "padding" : "margin"}-top: ${theme.design.typography.spacing.base};
                    `);
                }

                return output;
            }}
        `,
    };
};

export const typographyGetNoResultsAltProps = (
    parameters: TypographyNoResultsParameters = {},
): TypographyPresentationProps => {
    const { separated, spaced } = parameters;

    return {
        forwardAs: "p",
        css: css`
            ${typographyTitleStyles(pxToRemArray([16, null, 18, null, 20]))}
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
            text-align: center;

            ${() => {
                const output = [];

                if (separated) {
                    output.push(css`
                        border-top: ${pxToRem(1)} solid ${getColor("common.border")};
                    `);
                }

                if (separated || spaced) {
                    output.push(css`
                        ${breakpointValues(
                            pxToRemArray([20, 30, 40, null, 50]),
                            `${separated ? "padding" : "margin"}-top`,
                        )}
                    `);
                }

                return output;
            }}
        `,
    };
};
